function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.1 17.3l-3.88 3.9-1.4-1.42 3.84-3.85-1.7-.65 1.08-.73-2.93-2.2L2.5 11l1.36-.06 2.8 1.83-3.1-4.05v-1.7L5 7.6l2.65 3.16-1.1-4.63.33-1.92 1.24 1.44L9.22 10l.66-6.12.92-1.6.75 1.63-.43 5 2.66-5.04 1.45-1.22.06 1.82-2.66 5.26 4.2-3.9 2.22-.87-.87 2.23-3.9 4.2 5.24-2.65 1.82.07-1.22 1.45-5.06 2.66 5-.42 1.62.75-1.6.92-6.1.66 4.35 1.1 1.42 1.25-1.93.33-4.63-1.1L16.4 19l.6 1.45-1.72-.02-4.05-3.1 1.83 2.8L13 21.5l-1.34-.6-2.2-2.93-.74 1.07-.6-1.73zM7.3 16h.72v.74l3.98-4.2L14 10l-2.5 2-4.2 4z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationScrub = function SvgLocationScrub(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationScrub;